import { FormEvent, useState } from 'react'
import { Alerta, Boton, Campo, Dialogo, Entrada, Seleccion } from '../kit'
import { useCrearRecinto } from '../../queries/useInventario'
import { Recinto, Sector } from '../../types/inventario'
import { mensajeDeError } from '../../utils/errores'
import { SECTOR } from '../../utils/inventario'

/** Una oficina o sala nueva. Parte con la plancheta desactualizada. */
export function DialogoRecinto({ onCerrar, onCreado }: { onCerrar: () => void; onCreado: (r: Recinto) => void }) {
  const crear = useCrearRecinto()
  const [d, setD] = useState({ codigo: '', nombre: '', sector: 'NORTE' as Sector, piso: '' })
  const guardar = (e: FormEvent) => {
    e.preventDefault()
    crear.mutate(d, { onSuccess: onCreado })
  }
  return (
    <Dialogo abierto onCerrar={onCerrar} titulo="Nueva oficina">
      <form className="pila" onSubmit={guardar}>
        <div className="formulario-grilla">
          <Campo etiqueta="Sector" requerido>
            <Seleccion value={d.sector} onChange={(e) => setD({ ...d, sector: e.target.value as Sector })}>
              {(Object.keys(SECTOR) as Sector[]).map((s) => (
                <option key={s} value={s}>{SECTOR[s]}</option>
              ))}
            </Seleccion>
          </Campo>
          <Campo etiqueta="Piso">
            <Entrada type="number" inputMode="numeric" value={d.piso} onChange={(e) => setD({ ...d, piso: e.target.value })} />
          </Campo>
        </div>
        <Campo etiqueta="Nombre" requerido ayuda="Como en la plancheta: «OF. 310», «SALA DICHATO».">
          <Entrada value={d.nombre} onChange={(e) => setD({ ...d, nombre: e.target.value })} required data-autofocus />
        </Campo>
        <Campo etiqueta="Código" requerido ayuda="Único. Sector + piso + recinto, como N3-OF310 o P2-PASILLO.">
          <Entrada value={d.codigo} onChange={(e) => setD({ ...d, codigo: e.target.value })} required autoCapitalize="characters" autoComplete="off" />
        </Campo>
        {crear.isError && <Alerta tipo="error">{mensajeDeError(crear.error)}</Alerta>}
        <div className="acciones-formulario">
          <Boton variante="text" onClick={onCerrar}>Cancelar</Boton>
          <Boton type="submit" cargando={crear.isPending}>Crear oficina</Boton>
        </div>
      </form>
    </Dialogo>
  )
}
